module.exports = __webpack_public_path__ + "media/images/flags/1x1/nir-7d7437dba23d7f7f43cc0f94ec1cd5a0.svg";